import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const Inbox = () => {

    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default Inbox;